import { useQuery } from '@tanstack/react-query';
import { DashboardService } from '../services/dashboardService';
import { Dashboard } from '../types/Dashboard';

export const useAvailableDashboards = (
  workspaceId?: string,
  scope?: 'platform' | 'organization' | 'product',
  tabId?: string,
  orgId?: string
) => {
  const {
    data: availableDashboards = [],
    isLoading,
    error,
    refetch,
  } = useQuery<Dashboard[]>({
    // PBI #78540: orgId entra na queryKey + no request, igual ao grid
    // (useDashboards). Sem isso, superadmin navegando para o workspace de
    // outra org via SuperAdminOrgContext recebe lista vazia — o backend cai
    // na org-casa do superadmin e nenhum dashboards_base casa com o product.
    queryKey: ['available-dashboards', orgId, workspaceId, scope, tabId],
    queryFn: () => DashboardService.getAvailableDashboards({ workspaceId, scope, tabId, orgId }),
    staleTime: 5 * 60 * 1000,
  });

  return {
    availableDashboards,
    isLoading,
    error,
    refetch,
  };
};
